




























import { Vue, Component, Prop, Watch } from "@/shared/vuepack";
import QsReportLink from "@/employer/components/reports/QsReportLink.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import _ from "lodash";
import { FetchState, QuickSightUserReport } from "@/shared/types";
import { useQuicksightStore } from "@/shared/store/quickSight";

const ELEMENTS_PARTNER_ID = 4;

@Component({
  components: {
    ReportLink: QsReportLink,
    GenericLoadingSpinner
  }
})
export default class ReportsQS extends Vue {
  qSStore = useQuicksightStore();

  @Prop() routeToRenderReport: (dashboardId: string) => any;
  @Prop() routeToName: string;
  @Prop() reportName: string;
  @Prop() partnerId: number;
  @Prop() employerId: number;
  @Prop() dashboardId: string;
  loadedReportName = "";

  userReportCategoryName (categoryName: string): string {
    return _.capitalize(categoryName);
  }

  userReportToRoute (userReport: QuickSightUserReport): any {
    const segments = userReport.quickSightLinkId.split("/");
    return this.routeToRenderReport(segments[segments.length - 1]);
  }

  get userReportRows () {
    return _.chunk(_.keys(this.qSStore.userReports).sort(), 3).map(chunk =>
    chunk.map(category => ({ category, reports: this.qSStore.userReports[category]})));
  }

  get showListing () {
    return !this.dashboardId;
  }

  get isLoading () {
    return this.qSStore.fetchState === FetchState.Loading;
  }

  mounted () {
    this.onChangeReportName();
    this.qSStore.getUserReports({ employerId: this.employerId, partnerId: this.partnerId});
  }

  @Watch("$props.dashboardId")
  onChangeReportName () {
    this.loadedReportName = "";
    this.loadReports();
  }

  cleanupIframe () {
    if (this.$refs.embedContainer) {
      const c = this.$refs.embedContainer as any;
      const existingIFrame = c.querySelector("iframe");
      if (existingIFrame) {
        c.removeChild(existingIFrame);
      }
    }
  }

  get embedParameters () {
    return this.employerId ?
      { EmployerId: this.employerId }
      :
      { PartnerId: this.partnerId };
  }

  get showElements () {
    return this.partnerId === ELEMENTS_PARTNER_ID;
  }

  triggerReportEmbed () {
    const parameters = {... this.$route.query, ...this.embedParameters };
    return this.qSStore.embed({
      elem: this.$refs.embedContainer,
      id: this.dashboardId,
      parameters});
  }

  loadReports () {
    this.cleanupIframe();
    if (this.loadingReport) {
      const loadingReportName = this.dashboardId;
      this.triggerReportEmbed()
        .then(_ => this.loadedReportName = loadingReportName);
    }
  }

  get loadingReport () {
    return this.dashboardId && this.dashboardId !== this.loadedReportName;
  }
}
